import { Button } from '@/components/ui/button'
import { useState } from 'react'
import { Link, router, usePage } from '@inertiajs/react'
import Loading from '@/components/ui/loading';
import { useToast } from '@/hooks/use-toast';
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { LayoutGrid, LogOut, Settings, User } from 'lucide-react';
import { useMobileNavigation } from '@/hooks/use-mobile-navigation';
import { LoaderProvider } from '@/hooks/loader-context';
import AxiosLoader from '@/components/ui/axios-loading';
const Header = () => {
    const activeCLass = "border-b-2 border-black border-dashed pb-1 font-bold dark:border-white";
    const [loading, setLoading] = useState(false);
    const { showToast } = useToast();
    const {props}:any = usePage();
    const user = props.auth.user
    const cleanup = useMobileNavigation();
    const isDark = document.documentElement.classList.contains('dark');

    router.on('start', () => {
        setLoading(true);
    })

    router.on('success', (e) => {
        if (e?.detail?.page?.props?.flash?.message) {
            showToast({
                title: e.detail.page.props.flash.message,
                // description: e.detail.page.props.flash.message,
                type: "SUCCESS",
            });
        }
    })

    router.on('error', (e) => {
        if (Object.keys(e?.detail?.errors).length > 0) {
            let errorMessage = e.detail.errors[Object.keys(e.detail.errors)[0]];
            showToast({
                title: errorMessage,
                // description: e.detail.page.props.flash.message,
                type: "ERROR",
            });
        }
    })

    router.on('finish', () => {
        setLoading(false)
    })
    return (
        <>
            <LoaderProvider>
                <AxiosLoader />
                <Loading loading={loading} />
                <div className="flex items-center justify-between px-6 py-4 gap-4  dark:bg-black dark:border-[#333]">
                    
                    <div className="flex items-center gap-2">
                    <Link href={route("landing.home")}>
                        {isDark ? <img src={'/assets/logo_inner.png'} /> : <img src={'/assets/logo.png'} className='h-[50px]' />}
                    </Link>
                    </div>

                    <div className="flex items-center gap-4">
                    
                    <nav className="hidden md:flex gap-6 text-sm font-medium pr-2 border-r-2 border-[#C9C9C9] dark:border-[#444]">
                        <Link
                            href={route("landing.home")}
                            className={`mr-3 text-black dark:text-white ${route().current() == "landing.home" ? activeCLass : ''}`}
                        >
                        Home
                        </Link>
                        {/* <Link href="#" className="text-black dark:text-white">Pricing</Link>
                        <Link href="#" className="text-black dark:text-white">Services</Link> */}
                        {/* <Link href="#" className="text-black dark:text-white">API Documentation</Link> */}
                    </nav>

                    {user ? (
                        <DropdownMenu>
                        <DropdownMenuTrigger className="relative outline-none">
                            <div className="flex items-center space-x-2 cursor-pointer">
                            <User className="w-6 h-6 text-gray-600 dark:text-gray-300" />
                            <span className="text-sm text-gray-700 dark:text-gray-200 font-medium">
                                Hi {user.name.charAt(0).toUpperCase() + user.name.slice(1)}
                            </span>
                            </div>
                        </DropdownMenuTrigger>

                        <DropdownMenuContent className="w-48 bg-white dark:bg-[#2a2a2a] text-black dark:text-white border border-gray-200 dark:border-gray-600">
                            <DropdownMenuGroup>
                            <DropdownMenuItem asChild>
                                <Link className="block w-full" href={route('dashboard.index')} as="button" onClick={cleanup}>
                                <LayoutGrid className="mr-2" />
                                Dashboard
                                </Link>
                            </DropdownMenuItem>
                            <DropdownMenuItem asChild>
                                <Link className="block w-full" href={route('profile.edit')} as="button" onClick={cleanup}>
                                <Settings className="mr-2" />
                                Settings
                                </Link>
                            </DropdownMenuItem>
                            </DropdownMenuGroup>
                            <DropdownMenuSeparator className="dark:border-gray-600" />
                            <DropdownMenuItem asChild>
                            <Link className="block w-full" method="post" href={route('logout')} as="button" onClick={cleanup}>
                                <LogOut className="mr-2" />
                                Log out
                            </Link>
                            </DropdownMenuItem>
                        </DropdownMenuContent>
                        </DropdownMenu>
                    ) : (
                        <div className="flex gap-2">
                        <Link href={route("landing.login")}>
                            <Button>Login</Button>
                        </Link>
                        <Link href={route("landing.signup")}>
                            <Button className="cursor-pointer" variant="outline">
                            Sign Up
                            </Button>
                        </Link>
                        </div>
                    )}
                    </div>
                </div>
            </LoaderProvider>
        </>
    )
}

export default Header
